import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { MessageService } from '../../../services/message.service';
import { UnidadesEmpresaParametrosNfceService } from '../../../services/unidades-empresa-parametros-nfce.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-vincular-paf',
  templateUrl: './vincular-paf.component.html',
  styleUrls: ['./vincular-paf.component.scss']
})
export class VincularPafComponent extends ModalCadastroComponent implements OnInit {
  @ViewChild('modalCadastro', { static: true }) modalCadastro;

  @Input() inscricaoEstadual: string;
  @Input() nomeEmpresa: string;
  @Input() unidadeEmpresaId: any;
  @Output() closed = new EventEmitter<any>();
  protocolo: string = '';
  form: FormGroup;

  constructor(private messageService: MessageService,
    private parametrosService: UnidadesEmpresaParametrosNfceService
  ) {
    super();
  }

  ngOnInit() {
    this.inscricaoEstadual = this.prop.inscricaoEstadual.trim();
    this.nomeEmpresa = this.prop.nomeEmpresa;
    this.unidadeEmpresaId = this.prop.unidadeEmpresaId;

    this.form = new FormGroup({
      unidadeEmpresaID: new FormControl(this.unidadeEmpresaId),
      protocolo: new FormControl(null),
      desativado: new FormControl(false)
    });
  }

  show() {
    this.modalCadastro.show();
  }

  onClose() {
    this.closed.emit();
  }

  salvar() {
    const dados = {
      unidadeEmpresaID: this.form.get('unidadeEmpresaID')?.value,
      protocolo: this.form.get('protocolo')?.value,
      desativado: this.form.get('desativado')?.value
    };

    this.parametrosService.alterarPafNfce(dados).subscribe({
      next: res => {
        this.messageService.success("Protocolo salvo com sucesso!", 5000);
        this.closed.emit({ protocolo: this.protocolo });
        this.modalCadastro.hide();
      },
      error: err => {
        this.messageService.error(err, 30000, 'Erro ao protocolar PAF NFC-e!');
      }
    });
  }
}